/**
 * RegionMemberEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { RegionEntity } from "../RegionEntity";
import { PersonEntity } from "../PersonEntity";
import { RegionMemberEntity } from "../RegionMemberEntity";
declare global {
    interface EntityTypeMap {
        RegionMember: RegionMemberEntity;
    }
}
export abstract class RegionMemberGeneratedEntity extends BaseEntity {
    public abstract regionMemberId: string;
    public abstract templateId: string | null;
    public abstract type: string;
    public abstract region: RegionEntity;
    public abstract person: PersonEntity | null;
}
